import { createContext, useContext } from 'react';
import type { ImageSlot } from '../lib/image-slots-client';
import type { ContentType } from '../lib/content-slots-client';

export interface ContentEditRequest {
  slotId: string;
  currentContent: string;
  fallback: string;
  contentType: ContentType;
  pageSection: string;
  label: string;
}

export interface EditModeContextValue {
  active: boolean;
  onEditSlot: (slotId: string, currentSlot: ImageSlot | null, fallbackSrc: string) => void;
  onEditContent: (req: ContentEditRequest) => void;
  onEditController?: (controllerId: string) => void;
}

const noop = () => {};

export const EditModeContext = createContext<EditModeContextValue>({
  active: false,
  onEditSlot: noop,
  onEditContent: noop,
});

export function useEditMode() {
  return useContext(EditModeContext);
}
